module.exports = __webpack_public_path__ + "static/media/little_victory_4_filter.cd85d077.png";